<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.va_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="va_vendname">
            <label class="weui-form-preview__label">{{customLabel.va_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.va_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="va_sendcode">
            <label class="weui-form-preview__label">{{customLabel.va_sendcode || "送货单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.va_sendcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_payments">
            <label class="weui-form-preview__label">{{customLabel.va_payments || "付款方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.va_payments }}
              <span v-if="form.main.va_currency">
                {{ form.main.va_currency }}</span
              >
              <span v-if="form.main.va_rate && form.main.va_rate != 1">
                / {{ form.main.va_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="va_date">
            <label class="weui-form-preview__label">{{customLabel.va_date || "收料日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.va_date
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.vad_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="vad_pucode">
            <label class="weui-form-preview__label">{{customLabel.vad_pucode || "采购单号"}}</label>
            <span class="weui-form-preview__value">{{ item.vad_pucode }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              item.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{ item.pr_spec }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vad_prodcode">
            <label class="weui-form-preview__label">{{customLabel.vad_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              item.vad_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vad_qty">
            <label class="weui-form-preview__label">{{customLabel.vad_qty || "收料数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ item.vad_qty }} {{ item.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="vad_qty_extra" v-if="item.vad_qty_extra">
            <label class="weui-form-preview__label">{{
              customLabel.vad_qty_extra || "辅助数量"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ item.vad_qty_extra }} {{ item.pr_unit_extra }}</span
            >
          </div>
          <div class="weui-form-preview__item" v-if="item.iqc_code" slot="iqc_result">
            <label class="weui-form-preview__label">{{customLabel.iqc_result || "检验结果"}}</label>
            <span class="weui-form-preview__value">{{ item.iqc_result }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqc_code" slot="iqc_okqty">
            <label class="weui-form-preview__label">{{customLabel.iqc_okqty || "合格数量"}}</label>
            <span class="weui-form-preview__value">{{ item.iqc_okqty }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqc_code" slot="iqc_ngqty">
            <label class="weui-form-preview__label">{{customLabel.iqc_ngqty || "不合格数量"}}</label>
            <span class="weui-form-preview__value">{{ item.iqc_ngqty }}</span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/purcverifyapply",
      caller: "PurcVerifyApply",
      xtype: "stock-purcVerifyApply-formpanel",
    };
  },
};
</script>